import type { ComponentProps, ReactNode } from 'react'
import useMeasure from 'react-use-measure'
import { motion } from 'motion/react'

export const ResizablePanel = ({
	children,
	shouldResize = true,
	...props
}: ComponentProps<typeof motion.div> & {
	children: ReactNode
	shouldResize?: boolean
}) => {
	const [ref, { height }] = useMeasure()

	return (
		<motion.div
			animate={shouldResize ? { height } : { height: 'auto' }}
			{...props}
		>
			<div ref={ref}>{children}</div>
		</motion.div>
	)
}
